import React from 'react'
import Background from 'components/Background'

const CodeSetsViewBackground = () => (
  <Background height="45vh" />
)
export default CodeSetsViewBackground
